// @ts-check
/**
 * Modul záložek (R-15 sekce 2, FR-2-47): kořen `[data-module="tabs"]` obaluje `[role="tablist"]`
 * i všechny `[role="tabpanel"]` (detail zadávacího postupu, pages/catalog/detail.gohtml,
 * `section[data-testid="detail-tabs"]`). Jen obal nad sdíleným `lib/tabs.js` — chování, klávesy
 * a URL viz tam; žádné `data-*` texty, žádný `fetch`. Bez modulu jsou záložky odkazy `?tab=`
 * a stránka funguje celá ze serveru.
 */

import { initTabs } from './lib/tabs.js';

/** @param {HTMLElement} root */
export default function init(root) {
  initTabs(root);
}
